<template>
  <component :is="roomComponent" :room="room"></component>
</template>
<script>
import {getCamStudyV2HomeUrl, getCamStudyV2RootUrl} from '@/utils/CamStudyV2Helper'
import {mapActions} from 'vuex'
import Room from "@/components/Room/Room.vue"

export default {
  name: 'RoomProxy',
  components: {
    // 동적 로딩
    'Room': () => import('@/components/Room/Room.vue'),
    'RoomCamStudy': () => import('@/components/Room/RoomCamStudy.vue'),
  },

  data() {
    return {
      room: null,
      roomType: '',
      v2CamsHomeUrl: '',
    }
  },
  computed: {
    roomComponent() {
      switch (this.roomType) {
        case '':
          return;
        case 'cam_study':
        case 'camstudy':
        case 'camstudy_m':
          return 'RoomCamStudy';
        default:
          return 'Room';
      }
    }
  },
  created: async function() {
    let roomId = this.$route.params.roomId,
        roomUrlId = this.$route.params.roomUrlId
    this.v2CamsHomeUrl = getCamStudyV2HomeUrl();
    // 다국어 설정
    this.$i18n.setLocale()
    this.room = await this.handleCheckRoom(roomId, roomUrlId);
    if (!this.room){
      const message = this.$t('room.closed')
      await this.handleRedirect(message, this.v2CamsHomeUrl, null)
      return
    }
    const isPremium = await this.validUserPremium()
    if (this.room?.mobileCamStudy) {
      const isEnterAll = this.room?.enterAll || this.room?.roomLevel === 'FREE_PLUS'
      if (
        isEnterAll || isPremium
      ) {
        await this.processRenderingRoom();
      } else {
        const message = this.$t('camstudy.alert.notPremiumPlusUser')
        await this.handleRedirect(message, this.v2CamsHomeUrl, null)
      }

      if (this.room?.roomLevel === 'FREE_PLUS') {
        await this.getCamStudyTrialInfo()
      }
    } else {
      await this.processRenderingRoom()
    }
  },
  methods: {
    ...mapActions('room', ['checkRoom']),
    ...mapActions('camstudy', ['checkUserPremium', 'getCamStudyTrialInfo']),
    async handleCheckRoom(roomId, roomUrlId) {
      try {
        let checkRoom = (await this.checkRoom({roomId, roomUrlId})).data;
        if (!checkRoom || !checkRoom.roomType || !checkRoom.mobileCamStudy) {
          throw new Error('NONE_ROOM');
        }
        return checkRoom;
      } catch (e) {
        console.error(e);
        switch (e.message) {
          case 'NONE_ROOM':
            if(this.$CookieUtils.value('GRM-ROOM-VERSION')){
              this.$CookieUtils.remove('GRM-ROOM-VERSION');
              let reloadInfo = JSON.parse( sessionStorage.getItem('_v3_room_reload_') || '{}' );
              try{
                if(reloadInfo.url != location.href){
                  reloadInfo = {
                    url: location.href,
                    loop: 1
                  };
                }else{
                  reloadInfo.loop = (reloadInfo.loop || 0) + 1;
                }

                if(reloadInfo.lastDate){
                  if(Date.now() - reloadInfo.lastDate > 1000*60){
                    reloadInfo.loop = 1;
                  }
                }
                reloadInfo.lastDate = Date.now();

                if(reloadInfo.loop <= 2){
                  location.reload();
                  return;
                }
              }finally{
                sessionStorage.setItem('_v3_room_reload_', JSON.stringify(reloadInfo));
              }
            }
            break;
        }
        return null
      }
    },
    async processRenderingRoom() {
      this.roomType = this.room.roomType
    },
    async validUserPremium() {
      try {
        const userPremiumInfo = (await this.checkUserPremium())?.data;
        return !!userPremiumInfo?.premium && userPremiumInfo?.userPremiumLevel === 'PREMIUM_PLUS';
      } catch (e) {
        return await this.handlePremiumCheckError(e)
      }
    },
    async handlePremiumCheckError(e) {
      const errMsgList = [
        'Empty Refresh Token Cookie',
        'Invalid access token',
        'Expired Refresh Token',
        'Invalid Refresh Token',
        'Multiple Access Token Cookie',
        'Multiple Refresh Token Cookie'
      ]
      if (errMsgList.includes(e?.message)) {
        const message = this.$t('camstudy.room.error.loginRequired', {'0': `${e.message}`})
        const url = getCamStudyV2RootUrl() + '/' + this.room.roomUrlId
        const routeLocation = process.env.NODE_ENV === 'local'
          ? { name: 'login', query: { redirect: location.pathname + location.hash } }
          : null
        await this.handleRedirect(message, url, routeLocation)
      } else {
        console.error('has not user premium data', e)
        await this.handleRedirect(this.$t('camstudy.alert.noPremiumData'), this.v2CamsHomeUrl, null)
      }
    },
    handleRedirect(message, url, routeLocation) {
      return new Promise(() => {
        this.$camsAlert({
          text: message,
          ok: () => {
            if (routeLocation) {
              this.$router.push(routeLocation)
            } else {
              window.location.href = url;
            }
          },
          onlyOk: true
        })
      })
    }
  },
}
</script>

